import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

/**
 * Transformer for canonical agent IDs between GQL strings and entities.
 */
export const TRANSFORMER = transformers.combine(
  graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.core.agent.Agent.Id.assertIsId,
    { warnOnly: true },
  ),
  graphql.transformers.IN.validate(
    transformers.PASS_THROUGH,
    ents.core.agent.Agent.Id.assertIsId,
    { warnOnly: true },
  ),
)
